// Add this script block below the description div
document.addEventListener('DOMContentLoaded', function() {
  const description = document.querySelector('.product-info__description .prose');
  const seeMoreButton = document.querySelector('.product-info__description .see-more');
  
  // Initially apply the 'description-short' class to limit height
  description.classList.add('description-short');
  
  // Get the max-height from CSS
  const maxHeight = parseInt(window.getComputedStyle(description).maxHeight, 10);
  
  // Check if content overflows the max-height
  if (description.scrollHeight > maxHeight) {
    seeMoreButton.style.display = 'inline'; // Show button if content is truncated
  } else {
    seeMoreButton.style.display = 'none'; // Hide button if no overflow
    description.classList.remove('description-short'); // Show full description
  }
  
  // Toggle description visibility on button click
  seeMoreButton.addEventListener('click', function() {
    if (description.classList.contains('description-short')) {
      description.classList.remove('description-short');
      seeMoreButton.textContent = 'See less...';
    } else {
      description.classList.add('description-short');
      seeMoreButton.textContent = 'See more...';
    }
  });
});